import type { ReactNode } from "react";
import type { ListQuery } from "@/api/types";
import type { ListPatch } from "@/hooks/use-local-list";

/** Shared props for resource tables used both on list pages (URL state) and inside detail tabs (local state). */
export interface ResourceTableProps<F extends object> {
  query: ListQuery<F>;
  onChange: (patch: ListPatch) => void;
  toolbar?: ReactNode;
  /** Column ids to omit (e.g. the organization column inside an organization page). */
  hide?: string[];
  /** Row click (e.g. open a preview drawer). */
  onRowClick?: (id: string) => void;
  filtered?: boolean;
}

export const tablePaging = <F extends object>(query: ListQuery<F>, total: number | undefined, onChange: (p: ListPatch) => void) => ({
  sort: query.sort,
  order: query.order,
  onSortChange: (sort: string, order: "asc" | "desc") => onChange({ sort, order, page: 1 }),
  page: query.page,
  pageSize: query.pageSize,
  total,
  onPageChange: (page: number) => onChange({ page }),
  onPageSizeChange: (pageSize: number) => onChange({ pageSize, page: 1 }),
});
